import { FormControl, Grid, TextField } from '@mui/material';
import { Controller, FieldError } from 'react-hook-form';

import { gridSize } from '@/shared/constants';

type IdentificacionTextFieldProps = {
  label: string;
  error: FieldError | undefined;
  helperText: React.ReactNode;
  disabled?: boolean;
  shrink?: boolean;
  required?: boolean;

  type?: React.HTMLInputTypeAttribute;

  size?: {
    xs: number;
    sm: number;
    md: number;
    lg: number;
  };

  onFetchCedulaRucInfo?: (value: any) => void;
  control: any;
  name: string;
  defaultValue?: string | number;
  selectedDocumentType: string;
};

const IdentificacionTextField: React.FC<IdentificacionTextFieldProps> = ({
  label,
  error,
  helperText,
  required = true,
  disabled = false,
  shrink = false,
  size = gridSize,
  type = 'text',
  onFetchCedulaRucInfo,
  control,
  name,
  defaultValue,
  selectedDocumentType,
}) => {
  return (
    <Grid item {...size}>
      <FormControl fullWidth variant="outlined">
        <Controller
          control={control}
          name={name}
          defaultValue={defaultValue}
          disabled={disabled}
          render={({ field }) => {
            const onChange = (event: any) => {
              const currentValue = event.target.value;
              const isNumber = /^[0-9]*$/.test(currentValue);

              if (
                isNumber &&
                (selectedDocumentType === 'CEDULA' ||
                  selectedDocumentType === 'CÉDULA') &&
                currentValue.length <= 10
              ) {
                field.onChange(currentValue);

                // fetch data from consulta-cedula api
                currentValue.length === 10 &&
                  onFetchCedulaRucInfo &&
                  onFetchCedulaRucInfo(currentValue);
              } else if (
                isNumber &&
                selectedDocumentType === 'RUC' &&
                currentValue.length <= 13
              ) {
                field.onChange(currentValue);

                // fetch data from consulta-ruc api
                currentValue.length === 13 &&
                  onFetchCedulaRucInfo &&
                  onFetchCedulaRucInfo(currentValue);
              }
            };

            return (
              <TextField
                fullWidth
                variant="outlined"
                label={label}
                disabled={disabled}
                InputLabelProps={{ ...(shrink && { shrink: true }) }}
                {...field}
                // {...register}
                error={!!error}
                helperText={helperText}
                type={type}
                required={required}
                onChange={onChange}
              />
            );
          }}
        ></Controller>
      </FormControl>
    </Grid>
  );
};

export default IdentificacionTextField;
